import { Controller } from "@hotwired/stimulus"

const TALLY_SCRIPT_SRC = "https://tally.so/widgets/embed.js"

export default class extends Controller {
  connect() {
    if (window.Tally) {
      window.Tally.loadEmbeds()
      return
    }
    this.#loadScript()
  }

  #loadScript() {
    let script = document.querySelector("script[data-tally-loader]")
    if (!script) {
      script = document.createElement("script")
      script.src = TALLY_SCRIPT_SRC
      script.async = true
      script.dataset.tallyLoader = "true"
      document.head.appendChild(script)
    }
    script.addEventListener("load", () => window.Tally?.loadEmbeds(), { once: true })
  }
}
